function MainLayout({ children }) {
  return <div className="w-4/5 px-4 h-full overflow-auto min-h-0">{children}</div>;
}

export { MainLayout };
